import React, { useState, useEffect } from 'react'
import { withTranslation } from 'react-i18next'
import styles from './FishingLicenceInformation.module.scss'
import { useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'
import BackNextButtons from 'shared/components/BackNextButtons.jsx'
import CommercialAquaculture from './CommercialAquaculture'
import FishingVessel from './FishingVessel'
import BackAnchor from '../../../../shared/components/BackAnchor'

const FishingLicenceInformationView = ({ t, i18n, setIsError }) => {
	const history = useHistory()

	const [commercialAquacultureValid, setCommercialAquacultureValid] = useState('')
	const [fishingVesselValid, setFishingVesselValid] = useState('')

	const [commercialAquacultureError, setCommercialAquacultureError] = useState('fishing_licence_info.commercial_fishing_error')
	const [fishingVesselError, setFishingVesselError] = useState('fishing_licence_info.commercial_fishing_error')

	const { fishingVessel, commercialAquaculture, vehicleType } = useSelector((state) => state.app)

	const backNextProps = {
		prevText: t('shared.cancel'),
		prevURL: i18n.language === "en" ? process.env.REACT_APP_PAGE_NOT_FOUND_URL : process.env.REACT_APP_PAGE_NOT_FOUND_URL_FR,//`/${i18n.language}${t('routes.address_update_question')}`,
		nextText: t('shared.next'),
	}

	useEffect(() => {
		try {
			if (vehicleType !== 'fisherman') {
				history.push(`/${i18n.language}${t('routes.your_info')}`)
			}
		} catch (e) {
			console.log(e)
			setIsError(true)
		}
	}, [])

	const onNext = () => {
		try {
			if (validateFields()) {
				history.push(`/${i18n.language}${t('routes.renewal_period')}`)
			}
		} catch (e) {
			console.log(e)
			setIsError(true)
		}
	}

	const validateFields = () => {
		try {
			validateCommercialAquaculture(commercialAquaculture)
			validateFishingVessel(fishingVessel)
			// if (commercialAquaculture === '' && fishingVessel === '') {
			// 	setCommercialAquacultureValid(false)
			// 	setFishingVesselValid(false)
			// }
			return (
				commercialAquacultureValid === true &&
				fishingVesselValid === true &&
				(commercialAquaculture !== '' || fishingVessel !== '')
			)
		} catch (e) {
			console.log(e)
			setIsError(true)
		}
	}


	const validateCommercialAquaculture = (name) => {
		try {
			const regex = RegExp(/^[a-z0-9]+$/i)
			setFishingVesselValid(true)
			setCommercialAquacultureValid(true)
			if (fishingVessel === '' && name === '') {
				setCommercialAquacultureValid(false)
				setFishingVesselValid(false)
				setCommercialAquacultureError('fishing_licence_info.commercial_fishing_error')
				setFishingVesselError('fishing_licence_info.commercial_fishing_error')
			}
			else if (name !== '') {
				if (regex.test(name)) {
					setCommercialAquacultureValid(true)
				} else {
					setCommercialAquacultureValid(false)
					setCommercialAquacultureError('fishing_licence_info.commercial_aquaculture_error_invalid')
				}
			}
		} catch (e) {
			console.log(e)
			setIsError(true)
		}
	}

	const validateFishingVessel = (name) => {
		try {
			const regex = RegExp(/^[a-z0-9]+$/i)
			setFishingVesselValid(true)
			setCommercialAquacultureValid(true)
			if (commercialAquaculture === '' && name === '') {
				setCommercialAquacultureValid(false)
				setFishingVesselValid(false)
				setCommercialAquacultureError('fishing_licence_info.commercial_fishing_error')
				setFishingVesselError('fishing_licence_info.commercial_fishing_error')
			}
			else if (name !== '') {
				if (regex.test(name)) {
					setFishingVesselValid(true)
				} else {
					setFishingVesselValid(false)
					setFishingVesselError('fishing_licence_info.fishing_vessel_error_invalid')
				}
			}
		} catch (e) {
			console.log(e)
			setIsError(true)
		}
	}


	return (
		<div>
			<div className="container">
				<div className="row">
					<div className="col-xs-12 col-lg-8">
						<BackAnchor />
					</div>
				</div>
				<div className="row">
					<div className="col-xs-12">
						<h1>{t('title')}</h1>
					</div>
				</div>
				<div className="row">
					<div className="col-xs-12 col-lg-8">
						<h2>{t('fishing_licence_info.give_your')}</h2>
					</div>
				</div>
				<div className="row">
					<div className="col-xs-12 col-lg-8">
						<CommercialAquaculture
							validateCommercialAquaculture={validateCommercialAquaculture}
							commercialAquacultureError={commercialAquacultureError}
							commercialAquacultureValid={commercialAquacultureValid}
							setIsError={setIsError}
						/>
						<FishingVessel
							validateFishingVessel={validateFishingVessel}
							fishingVesselError={fishingVesselError}
							fishingVesselValid={fishingVesselValid}
							setIsError={setIsError}
						/>
					</div>
				</div>
				<div className={styles['back_next_margin']}>
					<BackNextButtons props={backNextProps} nextOnClick={onNext} displayBack={true} />
				</div>
			</div>
		</div>
	)
}

export default withTranslation('common')(FishingLicenceInformationView)
